export function AccountDashboard({
  campaignsSection,
  keywordsSection,
  portfoliosSection,
  budgetUsageSection,
}: {
  campaignsSection: React.ReactNode;
  keywordsSection: React.ReactNode;
  portfoliosSection?: React.ReactNode;
  budgetUsageSection?: React.ReactNode;
}) {
  return (
    <div className="space-y-8 p-6">
      {campaignsSection}
      {keywordsSection}
      {portfoliosSection}
      {budgetUsageSection}
    </div>
  );
}
